import billingGroups from './billing-groups.json';

export default {
  billingGroups,
};
